import {
    createContext,
    useContext,
    useLayoutEffect,
    useMemo
} from "react";

import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

import fa from "../locales/fa";
import en from "../locales/en";

const LanguageContext = createContext(null);

const LANGUAGES = {
    fa: {
        code: "fa",
        dir: "rtl",
        translations: fa
    },
    en: {
        code: "en",
        dir: "ltr",
        translations: en
    }
};

const DEFAULT = "fa";

export function LanguageProvider({ children }) {

    const location = useLocation();

    const lang =
        location.pathname.match(/^\/(fa|en)(?:\/|$)/)?.[1] || DEFAULT;

    const current = LANGUAGES[lang];

    useLayoutEffect(() => {
        document.documentElement.lang = current.code;
        document.documentElement.dir = current.dir;
    }, [current.code, current.dir]);

    const changeLanguage = (newLang) => {

        if (!LANGUAGES[newLang]) return;

        const rest = location.pathname.replace(/^\/(fa|en)/, "");

        navigate(`/${newLang}${rest}`);
    };

    const value = useMemo(() => ({
        lang: current.code,
        dir: current.dir,
        isRTL: current.dir === "rtl",
        t: current.translations,
        changeLanguage
    }), [current, location.pathname]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}